var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 6.5C8.8 7.1 9.35 7.5 10 7.5C10.85 7.5 11.5 6.85 11.5 6C11.5 5.15 10.85 4.5 10 4.5C9.35 4.5 8.8 4.9 8.6 5.5H2.5C1.95 5.5 1.5 5.95 1.5 6.5V9.5H0V10.5H1.5V13.5C1.5 14.05 1.95 14.5 2.5 14.5H9.5C10.05 14.5 10.5 14.05 10.5 13.5V11.5H9.5V13.5H2.5V6.5H8.6ZM10 5.5C10.3 5.5 10.5 5.7 10.5 6C10.5 6.3 10.3 6.5 10 6.5C9.7 6.5 9.5 6.3 9.5 6C9.5 5.7 9.7 5.5 10 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.5V2.5C14.5 1.95 14.05 1.5 13.5 1.5H6.5C5.95 1.5 5.5 1.95 5.5 2.5V4.5H6.5V2.5H13.5V9.5H7.4C7.2 8.9 6.65 8.5 6 8.5C5.15 8.5 4.5 9.15 4.5 10C4.5 10.85 5.15 11.5 6 11.5C6.65 11.5 7.2 11.1 7.4 10.5H13.5C14.05 10.5 14.5 10.05 14.5 9.5V6.5H16V5.5H14.5ZM6 10.5C5.7 10.5 5.5 10.3 5.5 10C5.5 9.7 5.7 9.5 6 9.5C6.3 9.5 6.5 9.7 6.5 10C6.5 10.3 6.3 10.5 6 10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSystem);
export default __webpack_public_path__ + "static/media/ic-system.72caa3807f8615f25a6419e8d89464eb.svg";
export { ForwardRef as ReactComponent };